import React from "react";
import CrossCloseButton from "./parts/CrossCloseButton";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { closePopup } from "../redux/actions/modal";
export default function () {
  const Swal = require("sweetalert2");
  const dispatch = useDispatch();
  let history = useHistory();

  return (
    <div className="modal modal_w650" style={{ padding: "15px" }}>
      <div className="modal-supply__close">
        <CrossCloseButton className="custom-cross-btn_black" />
      </div>
      <div className="farm_modal__main">
        <button
          className="custom-button"
          style={{ margin: "0 3px" }}
          onClick={() => {
            history.push("/farm/hr");
            dispatch(closePopup());
          }}
          // onClick={() => {
          //   Swal.fire({
          //     title: "Coming Soon",
          //     imageUrl: "/assets/images/astr.png",
          //     showConfirmButton: false,
          //   }),
          //     dispatch(closePopup());
          // }}
        >
          <span style={{ fontSize: "14px" }}>HR TOKEN FARM</span>
        </button>
        <button
          className="custom-button"
          style={{ margin: "0 3px" }}
          onClick={() => {
            history.push("/farm/lpt");
            dispatch(closePopup());
          }}
          // onClick={() => {
          //   Swal.fire({
          //     title: "Coming Soon",
          //     imageUrl: "/assets/images/astr.png",
          //     showConfirmButton: false,
          //   }),
          //     dispatch(closePopup());
          // }}
        >
          <span style={{ fontSize: "14px" }}>LP TOKEN FARM</span>
        </button>
        <button
          className="custom-button"
          style={{ margin: "0 3px" }}
          onClick={() => {
            history.push("/farm/cohort");
            dispatch(closePopup());
          }}
        >
          <span style={{ fontSize: "14px" }}>COHORT TOKEN FARM</span>
        </button>
      </div>
    </div>
  );
}
